var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinyaLogo = function SvgPinyaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "scale(2.5) translateX(0.625rem)"
    },
    height: 21,
    viewBox: "0 0 246 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.12 70.03L22.64 62.67L26.12 55.31H33.09L36.57 62.67L33.09 70.03H26.12Z",
    fill: "#F2530D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.51 61.73L34.02 54.37L37.51 47.01H44.47L47.95 54.37L44.47 61.73H37.51Z",
    fill: "#F2530D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.76 78.07L34.28 70.71L37.76 63.35H44.73L48.21 70.71L44.73 78.07H37.76Z",
    fill: "#383A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 69.75L45.35 62.38L48.83 55.02H55.8L59.28 62.38L55.8 69.75H48.83Z",
    fill: "#F2530D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.05 86.08L22.57 78.72L26.05 71.36H33.02L36.5 78.72L33.02 86.08H26.05Z",
    fill: "#F2530D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.22 86.24L45.73 78.88L49.22 71.52H56.18L59.67 78.88L56.18 86.24H49.22Z",
    fill: "#F2530D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.11 63.22L60.36 77.42L56.88 70.06L60.11 63.22Z",
    fill: "#F2530D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.06 63.77L21.81 77.97L25.3 70.61L22.06 63.77Z",
    fill: "#F2530D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.78 87.64L50.47 90.82L49.32 87.33L55.78 87.64Z",
    fill: "#F2530D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.66 91.12L25.63 87.23L32.58 87.81L31.66 91.12Z",
    fill: "#F2530D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 92.51C4.7785 91.6411 9.13417 91.2089 13.5 91.22C23.6333 91.22 28.6967 96.22 28.69 106.22C28.69 117.267 23.5967 122.793 13.41 122.8C10.8861 122.801 8.38858 122.287 6.07 121.29V134.22H0.5V92.51ZM6.06 116.36C8.33564 117.469 10.8388 118.03 13.37 118C19.93 118 23.21 114.06 23.21 106.18C23.21 99.32 19.95 95.8833 13.43 95.87C10.9544 95.8388 8.48279 96.0802 6.06 96.59V116.36Z",
    fill: "#383A3A",
    stroke: "#383A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.86 122.8V91.22H59.62L60.62 95.22C63.573 92.6485 67.3543 91.2283 71.27 91.22C79.15 91.22 83.09 95.14 83.09 102.98V122.8H77.51V102.94C77.51 98.2733 75.1767 95.94 70.51 95.94C67.33 95.94 64.3033 97.2733 61.43 99.94V122.94L55.86 122.8Z",
    fill: "#383A3A",
    stroke: "#383A3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.33 91.22H94.33L103.33 115.88L112.56 91.22H118.46L105.33 123.73C103.01 129.457 99.5234 133.037 94.87 134.47L92.73 130.53C96.1601 129.079 98.912 126.381 100.43 122.98L88.33 91.22Z",
    fill: "#383A3A",
    stroke: "#383A3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.18 113.26C122.18 106.8 126.45 103.563 134.99 103.55C137.748 103.55 140.502 103.75 143.23 104.15V101.15C143.23 97.53 140.393 95.7167 134.72 95.71C131.332 95.7319 127.965 96.237 124.72 97.21V92.72C127.965 91.747 131.332 91.2419 134.72 91.22C144.1 91.22 148.79 94.4867 148.79 101.02V122.8H145.67L143.74 119.67C140.701 121.72 137.116 122.811 133.45 122.8C125.943 122.8 122.187 119.62 122.18 113.26ZM135 108.06C130.167 108.06 127.751 109.763 127.75 113.17C127.749 116.577 129.653 118.28 133.46 118.28C136.971 118.389 140.417 117.311 143.24 115.22V108.66C140.512 108.26 137.758 108.06 135 108.06Z",
    fill: "#383A3A",
    stroke: "#383A3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.98 79.73L33.13 114.88L41.3 123.28L49.03 114.88L44.95 79.73H37.98Z",
    fill: "#383A3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.33 23.58C61.33 23.58 41.18 20.78 41.33 44.66C41.33 44.66 61.19 29.62 61.33 23.58Z",
    fill: "#859A23"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.66 44.41C41.66 44.41 41.58 33.8 51.4 30.41C61.22 27.02 61.33 23.61 61.33 23.61C61.33 23.61 64.07 44.69 41.66 44.41Z",
    fill: "#B8D124"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 32.57C21.7 32.57 35.56 27.46 39.12 44.45C39.12 44.45 22.72 36.84 21.7 32.57Z",
    fill: "#859A23"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.87 44.32C38.87 44.32 37.29 36.77 29.79 35.87C22.29 34.97 21.7 32.57 21.7 32.57C21.7 32.57 23 48 38.87 44.32Z",
    fill: "#B8D124"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16C36 16 49.06 22.94 38.79 36.94C38.81 36.94 33.53 19.61 36 16Z",
    fill: "#859A23"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.74 36.63C38.74 36.63 43.3 30.41 39 24.22C34.7 18.03 36 16 36 16C36 16 25.42 27.27 38.74 36.63Z",
    fill: "#B8D124"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 47.13L54.9 53.87L49.18 53.79L45.6 47.13Z",
    fill: "#F2530D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.06 47.28L26.75 54.02L32.48 53.94L36.06 47.28Z",
    fill: "#F2530D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.63 91.89H166.86V124.35H170.63V91.89Z",
    fill: "#383A3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M214.42 124H208.94V109.81H194.78V124H189.33V92H194.83V105.33H208.99V92.01H214.47L214.42 124Z",
    fill: "#F39322"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M233.46 111.7H227.33V124H221.83V92H232.97C236.617 92 239.437 92.8267 241.43 94.48C243.423 96.1333 244.423 98.5333 244.43 101.68C244.498 103.586 243.963 105.466 242.9 107.05C241.816 108.544 240.332 109.701 238.62 110.39L245.73 123.71V123.99H239.84L233.46 111.7ZM227.33 107.22H232.99C234.564 107.308 236.113 106.801 237.33 105.8C237.854 105.307 238.265 104.707 238.536 104.041C238.807 103.375 238.931 102.658 238.9 101.94C238.946 101.209 238.841 100.477 238.592 99.7889C238.342 99.1007 237.954 98.4713 237.45 97.94C236.248 96.923 234.702 96.4042 233.13 96.49H227.33V107.22Z",
    fill: "#F39322"
  })));
};
export default SvgPinyaLogo;